import React, { Fragment, useEffect, useState } from "react";
import { ImgUserPlaceholder, SearchBadge } from "../../../assets/images";
import { getContactNameFromRoster } from "../../../Helpers/Chat/User";
import IndexedDb from "../../../Helpers/IndexedDb";
import PropTypes from "prop-types";
const indexedDb = new IndexedDb();
const avatarIcon = ImgUserPlaceholder;

export default function Badge(props) {
    const { userId, removeParticipant,isBlocked, image, thumbImage, isForwardFromWebChat=false, updateJid, userJid, groupId, groupJid, groupName } = props
    const nameToDisplay = getContactNameFromRoster(props);
    const [badgeImage, setBadgeImage] = useState(null);

    const checkNotFound = (event) => (event.target.src = avatarIcon);

    useEffect(() => {
        let fileImage = (thumbImage && thumbImage !== "") ? thumbImage : image;
        indexedDb
        .getImageByKey(fileImage, "profileimages", "")
        .then((blob) => {
            let blobUrl = window.URL.createObjectURL(blob);
            setBadgeImage(blobUrl);
        })
        .catch(() => {
        });
    },[image,thumbImage]);
    
    const updatedUrl = badgeImage || avatarIcon;

    return (
        <Fragment>
            {!isBlocked &&
            <li>
                <div>
                    <span className="badgeImg">
                        <img src={updatedUrl} 
                        onError={checkNotFound}
                        alt = {""}
                         />
                        </span>
                    <span title={nameToDisplay} className="badgeTitle">{nameToDisplay}</span>
                    <i onClick={ ()=>isForwardFromWebChat ? updateJid === undefined ? removeParticipant(groupJid, groupName, groupId) : removeParticipant(userId, userJid, updateJid) : removeParticipant(userId) } className="badgeAction"
                     onKeyDown={(e) => e.key === 'Enter' && isForwardFromWebChat ? updateJid === undefined ? removeParticipant(groupJid, groupName, groupId) : removeParticipant(userId, userJid, updateJid) : removeParticipant(userId)}
                     tabIndex="0"
                     role="button"
                        ><SearchBadge/></i>
                </div>
            </li>
            }
        </Fragment>
    )
}

Badge.propTypes = {
    userId: PropTypes.string,
    removeParticipant: PropTypes.func,
    isBlocked: PropTypes.bool,
    image: PropTypes.string,
    thumbImage: PropTypes.string
};